import { Button } from "./Button";
export function WatchingEmpty({ hasDevice=true }: { hasDevice?: boolean }) {
  if (!hasDevice) return <section className="pz-empty"><h1>No devices yet</h1>
    <p>Install Precyz on a device to see where your data goes. It observes connection metadata only — never the content of your traffic.</p>
    <Button href="/devices/install">Download for this device</Button></section>;
  return <section className="pz-empty" aria-live="polite"><span className="pz-pulse" aria-hidden="true"/>
    <h1>Watching</h1><p>Watching where your connections go.</p></section>;
}
